import './index.scss';

$ = jQuery;

var choice = [];

$('.our-product-filter__button').on('click', function () {
    var thisPanel = $(this).attr('data-panel');
    $('.our-product-filter__panel__select').removeClass('active');
    if ($(thisPanel).hasClass('active')) {
        $(thisPanel).removeClass('active');
        $('.our-product-filter__button').removeClass('active');
        if(!$('.has-filter-active').length) {
            $('.our-product-filter__button').addClass('active');
        }
        $('.our-product-filter__button').removeClass('has-filter-showing');
    } else {
        $('.our-product-filter__button').removeClass('active has-filter-showing');
        $(this).addClass('active has-filter-showing');
        $('.our-product-filter__panel').removeClass('active');
        $(thisPanel).addClass('active');

        choice = [];

        $(thisPanel + ' .filtering').each(function () {

            var thisId = $(this).attr('data-filter');
            choice.push('.' + thisId);
    
        });

        console.log(choice);
    }
});

$('.our-product-filter__panel__select').on('click', function () {
    if ($(this).hasClass('active') || $(this).hasClass('filtering') ) {
        $(this).removeClass('active filtering');
        var thisId = $(this).attr('data-filter');
        choice = choice.filter(function (value) {
            return value != '.' + thisId;
        });

    } else {
        $(this).addClass('active');
        var thisId = $(this).attr('data-filter');
        choice.push('.' + thisId);
    }

    console.log(choice);
});

$('.apply-choices-btn').on('click', function () {

    $('.has-filter-active').removeClass('has-filter-active');
    $('.has-filter-showing').addClass('has-filter-active');
    $('.has-filter-showing').removeClass('has-filter-showing');

    $('.our-product-filter__panel').removeClass('active');
    $('.our-products-search-form__input').val('');

    $('.our-product-filter__panel__select').removeClass('filtering');
    $('.our-product-filter__panel__select.active').addClass('filtering');


    if ($(this).hasClass('families-organise')) {
        $('.families-organised').addClass('active');
        $('.not-families-organised').removeClass('active');
    } else {
        $('.not-families-organised').addClass('active');
        $('.families-organised').removeClass('active');
    }

    choiceString = choice.join(',');

    $('.our-product').removeClass('active')

    if (choiceString) {
        console.log('choice exists' + choiceString);
        $(choiceString).addClass('active')
    } else {
        $('.our-product').addClass('active')
    }

    addLandscapePortrait();
    console.log(choice);

});

$('.reset-filter-btn').on('click', function () {

    $('.has-filter-showing').removeClass('has-filter-showing has-filter-active');

    $('.our-product-filter__panel').removeClass('active');
    $('.our-products-search-form__input').val('');

    $('.our-product-filter__panel__select').removeClass('active filtering');
    $('.our-product').addClass('active');

    $('.families-organised').addClass('active');
    $('.not-families-organised').removeClass('active');

    $('.our-product-filter__button').addClass('active');

    choice = [];

    addLandscapePortrait();
    console.log(choice);
});

$(".our-products-search-form__input").change(function () {
    this.form.submit();
});

$('.open-retailers').on('click', function (e) {
    e.preventDefault();
    $('.retailer-panel').not($(this).siblings('.retailer-panel')).removeClass('active');
    $(this).siblings('.retailer-panel').toggleClass('active');
});

$('.burger-menu').on('click', function () {
    $('.burger-menu').toggleClass('active');
    $('.new-drop-down-menu-container').toggleClass('active');
    $('.main-nav .logo').toggleClass('inactive');
    $('.home-header .logo').toggleClass('inactive');
    $('.home-header video').toggleClass('inactive');
    $('.home-header .banner-overlay').toggleClass('inactive');
    $('.mobile-banner').toggleClass('inactive');
});

function addLandscapePortrait() {
    var productThumbs = $(".our-product-image .wp-post-image, .our-products-main-image .wp-post-image");
    productThumbs.removeClass('landscape');
    productThumbs.removeClass('portrait');
    $('.our-product-image__inner').removeClass('landscape');
    $('.our-product-image__inner').removeClass('portrait');

    console.log('get landscape');
    productThumbs.each(function () {

        if ($(this).width() > $(this).height()) {
            //it's a landscape
            $(this).addClass('landscape');
            $(this).parent('.our-product-image__inner').addClass('landscape');
        } else if ($(this).width() < $(this).height()) {
            //it's a portrait
            $(this).addClass('portrait');
            $(this).parent('.our-product-image__inner').addClass('portrait');
        } else {
            //image width and height are equal, therefore it is square.
            $(this).addClass('landscape');
            $(this).parent('.our-product-image__inner').addClass('landscape');
        }

    });
}

addLandscapePortrait()

setTimeout(

    addLandscapePortrait

    , 500);

setTimeout(

    addLandscapePortrait

    , 5000);

setTimeout(

    addLandscapePortrait

    , 10000);